import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 496.000000 503.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
       
<g transform="translate(0.000000,503.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2085 3510 c-46 -7 -80 -21 -173 -68 -41 -22 -49 -52 -28 -117 9 -28
16 -74 17 -101 0 -27 4 -57 7 -67 8 -19 51 -45 97 -58 17 -4 62 -20 100 -34
39 -15 90 -34 115 -42 25 -8 59 -21 77 -29 17 -8 37 -14 45 -14 7 0 25 -6 40
-14 15 -8 41 -17 59 -21 18 -4 66 -23 107 -43 96 -46 188 -143 223 -234 l24
-63 3 -612 c2 -533 4 -613 17 -613 8 0 15 4 15 8 0 10 342 354 476 479 167
155 448 436 485 483 70 89 82 125 87 242 4 101 3 110 -21 150 -48 82 -104 117
-327 208 -30 13 -86 37 -125 55 -38 18 -81 36 -95 40 -14 4 -41 16 -60 26 -19
11 -38 19 -42 19 -4 0 -45 18 -92 40 -47 22 -89 40 -94 40 -5 0 -39 16 -76 35
-37 19 -72 35 -77 35 -6 0 -42 15 -82 34 -40 18 -103 46 -142 61 -84 32 -150
61 -188 80 -16 8 -34 15 -40 15 -6 0 -30 9 -54 20 -24 11 -63 29 -87 40 -52
24 -122 32 -191 20z"/>
<path d="M1469 2977 c-9 -7 -47 -50 -84 -97 -38 -47 -72 -87 -75 -90 -3 -3
-61 -70 -129 -150 -68 -80 -157 -181 -196 -225 -148 -163 -253 -296 -288 -365
-68 -131 -57 -285 26 -372 6 -7 43 -51 81 -98 38 -47 80 -96 94 -110 13 -13
30 -37 38 -52 8 -16 18 -28 22 -28 4 0 45 -48 92 -106 66 -83 323 -396 415
-507 8 -9 15 -20 15 -23 0 -17 112 -119 159 -145 49 -26 64 -29 147 -29 105 0
190 26 278 85 58 40 226 198 226 213 0 15 -53 30 -143 42 -43 5 -86 14 -97 20
-10 6 -47 13 -82 16 -35 3 -83 12 -108 19 -25 7 -61 16 -81 19 -21 4 -42 13
-49 21 -7 8 -19 15 -27 15 -52 0 -195 126 -240 213 l-28 52 3 260 c1 143 7
312 12 375 6 63 15 284 20 490 6 206 14 409 20 450 15 124 14 134 -21 107z"/>
<path d="M1894 1865 c11 -8 25 -15 32 -15 6 0 14 -7 18 -15 3 -8 14 -15 25
-15 10 0 21 -7 25 -15 8 -22 56 -39 70 -25 13 13 -9 30 -41 30 -12 0 -27 9
-33 20 -6 11 -19 20 -29 20 -11 0 -21 7 -25 15 -3 8 -17 15 -33 15 -27 -1 -27
-1 -9 -15z"/>
<path d="M2080 1761 c0 -13 27 -21 75 -21 55 0 67 15 17 24 -53 8 -92 7 -92
-3z"/>
<path d="M1794 1729 c-5 -9 39 -59 52 -59 3 0 31 -18 64 -39 32 -22 69 -42 82
-46 13 -4 28 -11 34 -16 6 -5 55 -20 110 -34 127 -32 344 -35 344 -5 0 4 -62
9 -139 12 -80 2 -144 8 -152 14 -8 6 -36 15 -63 19 -43 6 -102 28 -146 56 -8
5 -26 14 -40 21 -14 7 -43 26 -65 43 -48 37 -72 48 -81 34z"/>
<path d="M1680 1567 c0 -16 27 -40 105 -92 138 -91 247 -140 345 -155 184 -28
242 -32 325 -19 90 13 111 21 101 37 -4 8 -59 10 -165 6 -124 -3 -169 -1 -203
10 -23 8 -63 18 -88 22 -39 6 -226 87 -240 103 -3 4 -37 28 -76 54 -71 47
-104 58 -104 34z"/>
<path d="M321 775 c-122 -27 -248 -100 -271 -155 -11 -25 -10 -34 5 -57 17
-25 18 -26 25 -7 21 55 226 144 333 144 41 0 88 -16 99 -33 39 -61 -47 -180
-170 -239 -60 -29 -152 -49 -152 -33 0 4 25 51 55 104 53 93 66 131 46 131
-12 0 -51 -54 -51 -69 0 -6 -4 -11 -8 -11 -4 0 -18 -20 -30 -45 -12 -24 -37
-62 -57 -83 -21 -24 -35 -50 -35 -65 0 -15 -22 -75 -49 -134 -53 -116 -63
-154 -43 -160 6 -3 12 1 13 9 0 7 22 58 48 113 l48 100 21 -35 c41 -70 68 -99
122 -135 48 -32 61 -36 103 -32 26 2 56 12 67 22 19 17 21 17 38 2 28 -25 54
-21 103 17 l44 34 15 -32 c24 -49 48 -46 138 20 22 17 22 16 20 -17 -3 -30 0
-34 23 -37 33 -4 36 1 102 133 91 183 134 195 67 19 -44 -119 -48 -137 -24
-132 10 2 28 32 44 74 40 104 102 189 123 167 3 -3 -13 -34 -35 -70 -49 -78
-64 -157 -33 -180 29 -21 40 -16 103 42 33 30 62 55 66 55 3 0 6 -18 6 -40 0
-44 31 -86 57 -76 8 3 21 6 28 6 7 0 36 21 64 46 43 39 51 43 51 25 0 -11 10
-32 23 -47 29 -33 60 -29 111 17 l35 30 15 -35 c10 -24 22 -36 34 -36 21 0 82
38 123 77 l26 24 6 -41 c7 -51 22 -70 57 -70 41 0 103 54 170 147 47 65 20 59
-34 -8 -43 -55 -97 -99 -120 -99 -19 0 2 103 35 166 l33 66 48 -5 c55 -7 66
11 23 39 -14 9 -25 21 -25 28 0 6 20 40 45 75 24 35 42 68 39 72 -8 13 -57 10
-75 -4 -9 -7 -31 -41 -48 -75 -22 -43 -43 -70 -67 -84 -31 -18 -34 -25 -32
-58 1 -33 -5 -46 -49 -96 -73 -85 -100 -107 -117 -101 -18 7 -14 22 26 90 15
26 28 56 28 67 0 23 -65 88 -96 96 -54 14 -130 -37 -182 -121 -49 -81 -147
-165 -172 -150 -35 22 28 169 162 375 62 95 72 121 63 150 -9 28 -52 26 -98
-5 -39 -27 -48 -45 -21 -45 20 0 14 -20 -43 -133 -61 -122 -124 -218 -184
-279 -61 -63 -73 -52 -30 27 73 134 32 228 -63 145 l-35 -31 -3 33 c-4 45 -30
48 -68 7 -27 -30 -30 -31 -35 -13 -19 60 -38 63 -45 8 -7 -51 -22 -75 -102
-158 -56 -58 -98 -83 -98 -57 0 14 28 74 50 106 29 43 25 57 -25 104 -50 46
-71 49 -131 22 -56 -26 -101 -84 -125 -164 -30 -97 -52 -113 -111 -83 -49 26
-152 155 -160 201 -2 16 5 20 41 27 61 10 156 57 218 106 55 44 97 105 108
159 9 43 -10 104 -40 133 -32 30 -112 36 -204 15z m198 -51 c27 -34 28 -55 2
-25 -11 13 -25 20 -30 16 -6 -3 -9 0 -6 7 4 10 -5 13 -37 12 l-43 -2 40 7 c22
5 43 9 47 10 4 0 16 -11 27 -25z m-149 7 c-20 -4 -41 -10 -48 -15 -8 -5 -10
-2 -6 8 4 11 19 16 48 15 l41 -1 -35 -7z m-160 -51 c-19 -13 -30 -13 -30 0 0
6 10 10 23 10 18 0 19 -2 7 -10z m-80 -25 c-7 -8 -18 -15 -24 -15 -6 0 -2 7 8
15 25 19 32 19 16 0z m1370 -37 c0 -12 -1 -19 -3 -17 -1 2 -9 12 -16 22 -12
14 -11 17 3 17 10 0 16 -8 16 -22z m-1402 -2 c-7 -8 -15 -12 -17 -11 -5 6 10
25 20 25 5 0 4 -6 -3 -14z m1376 -39 c7 4 4 0 -6 -9 -11 -9 -19 -19 -18 -22 2
-25 -1 -30 -9 -18 -5 8 -4 24 3 38 6 13 13 19 14 13 2 -5 9 -6 16 -2z m-62
-90 c-7 -8 -8 -18 -4 -22 4 -5 1 -5 -5 -1 -10 5 -10 11 -1 26 7 11 14 17 17
15 2 -3 -1 -11 -7 -18z m570 -39 c-8 -8 -9 -4 -5 13 4 13 8 18 11 10 2 -7 -1
-18 -6 -23z m-582 -2 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11
6 0 10 -2 10 -4z m563 -31 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8
-4z m-1797 -46 c2 -53 81 -181 140 -226 45 -34 27 -43 -23 -12 -46 28 -62 46
-110 122 -41 65 -47 91 -31 125 15 30 23 28 24 -9z m1164 -43 c-44 -96 -62
-156 -57 -182 2 -13 0 -21 -4 -18 -25 15 10 152 57 221 13 20 24 40 24 46 0 6
2 8 5 5 3 -3 -8 -35 -25 -72z m603 37 c-24 -40 -26 -41 -18 -13 6 21 21 39 33
40 1 0 -5 -12 -15 -27z m-28 -3 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12
23 12 15 0z m-1195 -26 c0 -20 -29 -62 -98 -142 -53 -61 -82 -77 -82 -46 0 32
61 143 95 173 39 34 85 42 85 15z m873 9 c-7 -2 -13 -10 -13 -16 0 -14 -39
-66 -40 -53 0 5 7 18 17 28 12 14 13 18 3 18 -9 0 -7 5 6 15 10 8 24 14 29 14
6 0 4 -3 -2 -6z m107 -12 c0 -23 -109 -170 -140 -189 -11 -7 -25 -10 -30 -7
-22 14 42 141 94 187 37 33 76 37 76 9z m-1100 -4 c-8 -7 -16 -18 -18 -26 -4
-17 -42 -67 -42 -56 0 5 7 16 16 26 8 9 17 25 18 34 1 9 9 21 17 26 20 13 27
10 9 -4z m575 -6 c-3 -6 -11 -11 -16 -11 -5 0 -4 6 3 14 14 16 24 13 13 -3z
m-444 -52 c-12 -11 -21 -27 -21 -35 0 -9 -5 -12 -11 -8 -8 4 -9 -1 -5 -17 6
-20 5 -21 -4 -7 -8 14 -6 24 11 48 13 16 26 30 31 30 4 0 8 8 9 18 0 11 2 13
6 4 3 -8 -4 -22 -16 -33z m1163 4 c-4 -16 -10 -30 -13 -33 -3 -3 -7 -12 -8
-20 -1 -8 -6 -32 -11 -52 -6 -21 -6 -38 -2 -38 4 0 10 -7 14 -15 8 -21 -11
-19 -23 3 -10 19 6 132 19 132 4 0 11 11 14 25 4 14 9 25 11 25 3 0 2 -12 -1
-27z m-1356 -3 c-7 -10 -14 -17 -17 -15 -4 4 18 35 25 35 2 0 -1 -9 -8 -20z
m626 5 c-4 -8 -8 -15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z
m-250 -29 c-3 -15 -8 -25 -11 -23 -2 3 -1 17 3 31 3 15 8 25 11 23 2 -3 1 -17
-3 -31z m216 -1 c-7 -8 -9 -22 -6 -31 5 -14 4 -15 -8 -5 -13 11 -12 16 2 41 9
16 19 25 20 19 2 -5 -2 -16 -8 -24z m390 11 c0 -8 -7 -16 -15 -20 -13 -4 -14
-2 -5 14 13 23 20 26 20 6z m168 -41 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7
10 -15 7 -18z m-1162 -13 c-17 -16 -18 -16 -5 5 7 12 15 20 18 17 3 -2 -3 -12
-13 -22z m354 -14 c0 -16 -40 -82 -46 -76 -4 4 37 88 44 88 1 0 2 -6 2 -12z
m227 -20 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m570 10 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-573 -47 c9 -11 8 -13 -4 -9
-8 2 -16 18 -17 34 -1 18 0 22 4 9 3 -11 10 -26 17 -34z m-588 15 c0 -15 -5
-21 -10 -16 -5 5 -6 16 -3 24 9 23 15 19 13 -8z m171 -6 c1 -11 -2 -18 -8 -15
-11 7 -12 35 -1 35 4 0 8 -9 9 -20z m980 13 c-4 -3 -1 -13 6 -21 10 -13 9 -14
-3 -10 -19 6 -26 38 -9 38 7 0 9 -3 6 -7z m-163 -18 c3 -8 1 -15 -3 -15 -5 0
-11 7 -15 15 -3 8 -1 15 3 15 5 0 11 -7 15 -15z"/>
<path d="M2594 770 c-100 -14 -233 -74 -293 -131 -53 -51 -74 -125 -55 -196 9
-33 27 -28 21 4 -15 81 125 201 267 227 l39 7 -33 -58 c-127 -221 -190 -353
-197 -408 -7 -53 6 -37 42 50 28 67 88 187 127 250 10 17 21 37 25 45 3 8 17
32 30 53 13 21 22 45 21 55 -2 14 6 18 47 20 206 14 319 -127 240 -297 -31
-67 -142 -179 -212 -214 -131 -67 -308 -86 -396 -43 -21 10 -40 17 -42 14 -2
-2 5 -19 16 -37 28 -47 88 -71 179 -71 207 0 379 105 465 285 35 73 39 88 39
165 1 109 -20 166 -80 219 -58 51 -153 74 -250 61z m21 -40 c3 -5 1 -10 -4
-10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-49 -12 c4 -7 3 -8 -5
-4 -6 4 -18 2 -26 -4 -8 -7 -15 -8 -15 -3 0 23 33 32 46 11z m107 5 c-7 -2
-19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m77 -3 c-8 -5 -19 -10 -25 -10
-5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5 -5 -10z m-253 -26 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m338 -14 c10 -11 16 -20 13 -20 -3 0 -13
9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-385 6 c0 -3 -4 -8 -10 -11
-5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-65 -36 c-3 -5 -11 -10
-16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-55 -37 c0 -5 -13
-17 -28 -28 -27 -19 -27 -19 -12 0 22 29 40 42 40 28z m492 -360 c-73 -92
-148 -141 -263 -173 -80 -22 -163 -26 -221 -10 -57 16 -54 28 5 18 59 -11 160
2 243 32 29 11 55 16 58 13 3 -4 6 -1 6 5 0 7 5 12 11 12 17 0 121 77 149 110
37 43 47 37 12 -7z"/>
<path d="M4824 726 c-67 -57 -154 -197 -208 -331 -16 -38 -35 -83 -44 -100
-25 -49 -104 -145 -118 -145 -18 0 -19 -2 21 81 19 41 35 84 35 97 0 39 -18
62 -48 62 -30 -1 -48 -12 -78 -52 l-22 -28 -6 39 c-6 40 -29 70 -40 52 -3 -5
-3 -16 0 -25 15 -38 -137 -226 -183 -226 -18 0 -23 4 -19 18 3 9 10 37 16 62
7 25 22 66 35 92 24 48 20 64 -13 53 -9 -3 -42 -38 -72 -77 -30 -40 -72 -91
-93 -114 -40 -44 -92 -71 -103 -53 -20 33 46 186 150 344 76 115 94 158 76
180 -17 21 -45 19 -90 -7 -37 -21 -53 -48 -30 -48 22 0 7 -49 -46 -149 -69
-130 -127 -213 -188 -269 -42 -38 -76 -54 -76 -34 0 4 16 38 35 75 19 37 35
73 35 81 0 20 -87 96 -110 96 -57 0 -113 -43 -182 -141 -52 -73 -123 -142
-141 -136 -23 8 -12 90 21 161 l32 69 50 -5 c58 -6 66 9 23 40 -24 18 -26 23
-16 45 7 14 28 46 47 72 20 26 36 51 36 56 0 13 -62 10 -81 -4 -9 -7 -30 -40
-48 -74 -17 -35 -43 -70 -59 -80 -38 -24 -43 -34 -38 -65 6 -29 -35 -89 -109
-160 -69 -67 -86 -42 -35 51 17 30 30 61 30 70 0 20 -63 88 -89 96 -56 18
-144 -43 -190 -130 -38 -73 -24 -175 25 -175 20 0 68 25 83 44 16 20 41 21 41
3 0 -24 37 -50 62 -44 13 4 46 27 74 51 l52 45 6 -41 c8 -52 21 -68 53 -68 33
0 72 22 113 66 l35 36 5 -26 c7 -34 35 -66 59 -66 11 0 40 16 65 35 49 37 47
38 62 -13 12 -41 73 -20 143 49 28 27 52 49 55 49 3 0 6 -18 6 -41 0 -57 14
-79 51 -79 39 0 65 14 112 58 l37 36 0 -27 c0 -31 31 -67 58 -67 9 0 41 15 69
34 l52 34 -6 -28 c-4 -25 -2 -30 20 -35 14 -4 30 -4 36 -1 5 4 33 48 62 99 56
99 105 167 120 167 16 0 10 -16 -26 -76 -43 -71 -60 -123 -51 -157 13 -53 75
-40 134 27 42 49 52 46 45 -13 -5 -47 9 -115 27 -126 5 -3 6 18 3 47 -3 29 0
66 6 82 l12 29 27 -25 c54 -50 108 -62 150 -32 32 22 27 34 -12 27 -29 -4 -40
0 -72 30 l-38 34 60 29 c67 33 104 79 104 130 0 25 -7 38 -26 50 l-26 17 34
26 c100 78 177 195 163 248 -10 41 -24 53 -59 53 -22 0 -45 -11 -72 -34z m106
-9 c0 -2 -12 -2 -27 -1 -19 0 -36 -8 -50 -25 -13 -14 -23 -21 -23 -15 0 16 40
55 51 49 5 -4 9 -1 9 5 0 8 6 8 20 0 11 -6 20 -12 20 -13z m-5 -37 c11 -18
-45 -100 -113 -167 -35 -34 -69 -63 -74 -63 -5 0 -13 -11 -18 -25 -5 -14 -15
-25 -21 -25 -28 0 130 237 184 275 25 18 34 19 42 5z m-95 -27 c0 -3 -7 -3
-14 0 -9 4 -17 -2 -21 -14 -4 -10 -11 -19 -16 -19 -13 0 -11 7 7 29 15 16 44
19 44 4z m-755 -23 c-27 -12 -43 -12 -25 0 8 5 22 9 30 9 10 0 8 -3 -5 -9z
m-8 -52 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m708 22 c3 -6
-1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z m-733 -67 c-3 -9 -7 -9 -17
0 -7 7 -9 14 -4 15 5 2 9 13 10 25 1 20 2 20 8 -3 4 -14 6 -30 3 -37z m696 13
c-10 -7 -18 -16 -18 -19 0 -10 -42 -78 -46 -74 -6 5 20 57 29 57 4 0 7 6 7 13
0 16 20 37 35 37 5 0 2 -7 -7 -14z m-1283 -26 c-3 -5 -12 -10 -18 -10 -7 0 -6
4 3 10 19 12 23 12 15 0z m-36 -49 c-6 -17 -17 -35 -26 -42 -10 -9 -7 1 7 29
26 49 33 54 19 13z m550 -45 c-29 -50 -34 -45 -7 8 13 24 24 40 26 36 2 -4 -7
-24 -19 -44z m698 -11 c-4 -8 -12 -15 -19 -14 -10 0 -10 2 0 6 6 2 12 12 12
21 0 8 3 13 6 9 4 -3 4 -13 1 -22z m-29 -50 c-6 -14 -13 -23 -15 -21 -5 5 15
46 22 46 3 0 -1 -11 -7 -25z m-715 -29 c-10 -19 -22 -36 -26 -36 -5 0 2 18 14
40 28 49 37 46 12 -4z m867 19 c0 -14 -4 -25 -10 -25 -11 0 -14 33 -3 43 11
11 13 8 13 -18z m-1440 11 c0 -2 -9 -6 -20 -9 -11 -3 -20 -1 -20 4 0 5 9 9 20
9 11 0 20 -2 20 -4z m1398 -27 c4 -32 -56 -89 -93 -89 -31 0 -32 17 -1 59 48
65 88 78 94 30z m-1634 2 c13 -21 -135 -211 -165 -211 -33 0 21 128 78 185 33
33 75 46 87 26z m576 -7 c0 -31 -137 -204 -161 -204 -22 0 -18 28 15 95 20 40
50 85 67 99 35 30 79 35 79 10z m792 -7 c-7 -8 -8 -18 -4 -22 4 -5 1 -5 -6 -1
-9 5 -9 12 -1 27 6 12 13 18 16 15 3 -3 1 -12 -5 -19z m-1492 3 c0 -5 -5 -10
-11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m580 0 c0 -5 -2 -10
-4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m1041 -23 c-10 -9
-11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-1303 -29 c-12 -24 -21 -46
-20 -50 1 -4 -5 -22 -12 -40 -12 -28 -12 -37 0 -60 12 -24 12 -27 0 -22 -34
13 -22 108 22 175 33 51 38 50 10 -3z m-335 17 c-3 -9 -8 -14 -10 -11 -3 3 -2
9 2 15 9 16 15 13 8 -4z m177 6 c0 -6 -13 -25 -30 -43 -37 -40 -39 -25 -3 20
29 34 33 37 33 23z m392 -21 c-9 -16 -19 -25 -20 -20 -2 6 -12 0 -23 -12 -17
-21 -18 -21 -12 -3 10 28 33 51 34 33 0 -7 4 -3 9 10 5 12 14 22 19 22 6 0 2
-13 -7 -30z m915 6 c-3 -8 -1 -16 6 -19 8 -2 8 -5 -1 -11 -7 -4 -12 -2 -12 4
0 6 -5 8 -11 4 -8 -4 -8 0 0 15 13 24 26 29 18 7z m-1526 -24 c-14 -26 -14
-35 -1 -27 6 3 10 2 10 -4 0 -15 -18 -23 -25 -11 -7 12 14 74 22 66 3 -2 0
-13 -6 -24z m952 -20 c-9 -20 -19 -55 -22 -77 -4 -23 -9 -34 -12 -25 -8 19 31
151 42 145 4 -3 1 -22 -8 -43z m221 -12 c-9 -25 -14 -60 -12 -78 3 -24 0 -32
-10 -30 -28 6 -36 33 -19 64 9 16 24 44 33 61 24 44 26 37 8 -17z m544 -55
c46 -48 20 -44 -29 5 -39 40 -45 54 -32 86 5 14 9 10 17 -19 6 -20 26 -53 44
-72z m-971 36 c-16 -39 -27 -48 -27 -23 0 12 5 22 11 22 6 0 9 6 6 13 -3 8 1
14 8 14 10 0 11 -6 2 -26z m618 -11 c-14 -22 -25 -44 -25 -50 0 -5 -4 -10 -10
-10 -14 0 -13 4 11 47 18 32 36 52 47 53 1 0 -9 -18 -23 -40z m-1206 -12 c-7
-13 -14 -18 -16 -11 -3 7 2 19 9 27 18 20 22 12 7 -16z m408 0 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-600 -20 c-3 -7 -5 -2 -5 12 0 14 2
19 5 13 2 -7 2 -19 0 -25z m1517 -22 c-9 -29 -14 -33 -24 -16 -10 16 -3 33 11
25 5 -4 9 -2 9 4 0 5 -4 13 -10 16 -5 3 -10 12 -10 18 0 7 7 3 15 -7 9 -12 12
-29 9 -40z m-926 -2 c0 -15 -4 -22 -10 -16 -5 5 -6 16 -2 25 9 23 12 21 12 -9z
m177 -22 c-8 -8 -25 10 -25 26 0 13 2 13 14 -4 8 -10 13 -21 11 -22z m-581 12
c5 -14 4 -15 -9 -4 -17 14 -19 20 -6 20 5 0 12 -7 15 -16z"/>
<path d="M4206 495 c-19 -19 -31 -60 -21 -74 9 -16 41 -13 54 3 15 18 11 78
-5 83 -7 2 -19 -3 -28 -12z"/>
</g>
</svg>


    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
